module.exports = __webpack_public_path__ + "static/img/1.b06b01f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/1.png
// module id = o9Tn
// module chunks = 0